export const internalChat = {
  dm: "Direct Message",
  dmDescription:
    "Start a private conversation with one team member.",
  dmDescriptionShort:
    "Private 1:1 conversation with a team member",
  channel: "Channel",
  channelDescription:
    "Channels are where your team communicates. They can be organized around projects, topics, or anything else.",
  channelDescriptionShort:
    "Group channel for team discussions",
  newDM: "New Direct Message",
  newChannel: "Create Channel",
  selectUser: "Select User",
  channelName: "Channel Name",
  channelNameHelper: "e.g., general, engineering, marketing",
  channelDescriptionLabel: "Description (optional)",
  descriptionHelper: "What's this channel about?",
  visibility: "Visibility",
  public: "Public",
  publicHelper: "Anyone in the workspace can view and join",
  private: "Private",
  privateHelper: "Only invited members can view and join",
  addMembers: "Add Members",
  addMembersHelper:
    "You will be added automatically as the channel owner",
  optional: "optional",
  searchMembers: "Search for members...",
  privateNoMembers:
    "You can add members now or invite them later",
  createChannel: "Create Channel",
  channelCreated: "Channel created successfully",
  dmCreated: "Conversation started successfully",
  directMessages: "Direct Messages",
  channels: "Channels",
  exploreChannels: "Explore Channels",
  noConversations: "No conversations yet",
  startDM: "Start a new direct message",
  startConversation: "Start Conversation",
  noDMs: "No direct messages",
  noChannels: "No channels",
  createDM: "New message",
  search: "Search...",
  editChannel: "Edit Channel",
  editChannelDescription: "Update your channel settings.",
  invalidChannelName:
    "Channel name can only contain letters, numbers, hyphens, underscores, and spaces",
  channelNameRequired: "Channel name is required",
  addMembersDescription:
    "Select users to add to this conversation.",
  allUsersAdded:
    "All users are already in this conversation",
  noUsersFound: "No users found",
  searchUsers: "Search by name or email...",
  typeToSearch: "Start typing to search for users",
  currentMembers: "Current members: %{count}",
  addSelected: "Add %{count} Member(s)",
};
